export default __webpack_public_path__ + "static/media/actor.119e4c30.png";